import { useCallback } from 'react';
import { openSupportEmail } from '../../utils/openSupportEmail';
import { appInformation } from '../../utils/appInformation/appInformation';
import { SMLAnalytics } from '../analytics/sml/analytics';

export function useSupportEmail(email?: string, deviceId?: string) {
  return useCallback(() => {
    SMLAnalytics.trackSupportOpened('contact').catch(console.error);
    const buildVersion = appInformation.buildVersion ? `(${appInformation.buildVersion})` : '';
    openSupportEmail(
      `${appInformation.platform} ${appInformation.platformVersion}`,
      `${appInformation.version} ${buildVersion}`,
      deviceId,
      email
    ).catch((error) => console.error(error));
  }, [deviceId, email]);
}
